import AxiosInterceptor from "../utils/AxiosInterceptor";

export const bannerServices = {
  getBanner: (values) =>
    AxiosInterceptor().post(`/banner/getAllBanners`, values),
  getById: (id) => AxiosInterceptor().get(`/banner/getOneBanner/${id.id}`),
  add: (values) => AxiosInterceptor().post(`/banner/addBanner`, values),
  deleteBanner: (value) =>
    AxiosInterceptor().post(`/banner/deleteBanner`, value),
  changeStatus: (value) =>
    AxiosInterceptor().post(`/banner/changeStatus`, value),
  updateBanner: (values) =>
    AxiosInterceptor().post(`/banner/updateBanner`, values),
};
